import { useEffect } from "react";
import ReactDOM from "react-dom";

function Modal({ isOpen, onClose, title, children, closeOnOutsideClick = true, size = "md" }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: "max-w-md",
    md: "max-w-xl",
    lg: "max-w-3xl",
    xl: "max-w-5xl",
    xxl: "max-w-7xl",
    full: "max-w-[95vw]",
  };
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4">
      <div
        className="fixed inset-0 bg-slate-900/45 backdrop-blur-sm transition-opacity duration-300 dark:bg-black/65"
        onClick={() => closeOnOutsideClick && onClose()}
      />
      <div className={`relative w-full ${sizeClass} transform overflow-visible rounded-xl border border-slate-200 bg-surface-card shadow-2xl transition-all duration-300 dark:border-slate-800 dark:bg-slate-950`}>
        <div className="flex items-center justify-between border-b border-slate-200 px-3 py-2 dark:border-slate-800">
          <h3 className="text-sm font-bold text-brand-text-primary dark:text-slate-100">{title}</h3>
          <button
            onClick={onClose}
            className="rounded-lg p-1 text-slate-500 transition-colors hover:bg-slate-200 hover:text-slate-700 dark:text-slate-300 dark:hover:bg-slate-700 dark:hover:text-slate-100"
          >
            <svg
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="max-h-[85vh] px-3 py-3 dark:bg-slate-950 custom-scrollbar">{children}</div>
      </div>
    </div>,
    document.body
  );
}

export default Modal;
